import { render, staticRenderFns } from "./TeamMemberTeamRow.vue?vue&type=template&id=4d9765aa"
import script from "./TeamMemberTeamRow.vue?vue&type=script&lang=ts"
export * from "./TeamMemberTeamRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports